import * as _ from 'lodash';
import { differenceInDays } from 'date-fns';

export function getCardLabel(card) {
  return `${_.upperFirst(card.brand)}, *${card.last4}, expires ${_.padStart(
    card.exp_month,
    2,
    '0',
  )}/${card.exp_year}`;
}

export function getStripeElementsAppearance() {
  return {
    variables: {
      fontFamily: 'Inter, sans-serif',
      colorText: '#81959c',
      spacingGridRow: '27px',
      spacingGridColumn: '32px',
    },
    rules: {
      '.Label': {
        marginBottom: '3px',
        color: '#818c9c',
        fontSize: '12px',
        fontWeight: '500',
        letterSpacing: '0.01em',
        lineHeight: '18px',
      },
      '.Input': {
        padding: '14px 22px',
        border: 'none',
        borderRadius: '6px',
        backgroundColor: '#f4f4f6',
        color: '#3b3a3a',
        fontSize: '14px',
        fontWeight: '400',
        lineHeight: '20px',
      },
    },
  };
}

// `exp_month` is 1-based and the Date constructor's month is 0-based, so this
// lands on the first instant of the month *after* expiry — which is the moment
// the card expires. Not an off-by-one.
export function isCardExpired(card, now = new Date()) {
  const expiresAt = new Date(card.exp_year, card.exp_month, 1);

  return differenceInDays(expiresAt, now) <= 0;
}
